const domains = ['navercorp.com', 'linecorp.com', 'nsbc.co.kr'];

export default {
  LCS_SERVER_NAME: '',
  CAMPAIGNCODE_URL: '',

  ServiceURL: (() => {
    const { hostname } = location;
    const domain = domains.filter((value) => hostname.includes(value))[0];

    return {
      AUTH: `https://enterprise-auth.${domain}`,
      COMMON: `https://works-common.${domain}`,
      NOTIFY: `https://notify.${domain}`,
      BOARD: `https://board.${domain}`,
      TALK: `https://talk.${domain}`,
      MAIL: `https://mail.${domain}`,
      CALENDAR: `https://calendar.${domain}`,
      CONTACT: `https://contact.${domain}`,
      DRIVE: `https://ndrive.${domain}`,
      TASK: `https://task.${domain}`,
      FORM: `https://form.${domain}`,
      TEMPLATE: `https://template.${domain}`,
      ADMIN: `https://works-admin.${domain}`,
      WORKPLACE: '',
      CLOVANOTE: '',
      CSTALK: 'https://cxtalk.navercorp.com',
    };
  })(),
};
